import React from 'react';
import { Spinner } from 'react-bootstrap';
import Button from 'components/DesignSystem/Button';
import Accordion from 'components/Accordion';
import useAutomaticOptions from 'utils/hooks/flux/useAutomaticOptions';

import './index.scss';

export default function AutomaticFrequentScenarios() {
  const {
    labeledScenarios,
    isFetching,
    loadFrequentScenario,
    checkLabeledScenarios,
  } = useAutomaticOptions();

  const isFetchingBody = () => <Spinner animation="border" />;

  const bodyWithScenarios = () => labeledScenarios.map((labeledScenario) => {
    const alreadySelected = checkLabeledScenarios(labeledScenario);
    return (
      <div
        className="my-1 row text-left"
        key={labeledScenario.label}
      >
        <Button
          type="secondary"
          className={`frequent-scenario-button ${alreadySelected ? 'selected' : ''}`}
          onClick={() => loadFrequentScenario(labeledScenario)}
        >
          {labeledScenario.label}
        </Button>
      </div>
    );
  });

  const body = () => {
    if (isFetching) {
      return isFetchingBody();
    }
    return bodyWithScenarios();
  };

  return (
    <Accordion.Item eventKey="0">
      <Accordion.Header>Cenários Frequentes</Accordion.Header>
      <Accordion.Body>
        { body() }
      </Accordion.Body>
    </Accordion.Item>
  );
}
